<template>
  <div >
    <van-cell-group style="width: 100%">
      <van-cell>
        <van-button plain hairline round icon="success" size="small"
                      color="#4bb0ff"  @click="saveEdit"> 保存 </van-button>
      </van-cell>
      <van-field
              v-model="postItem.content" ref="postContent"
              rows="5"
              autosize
              type="textarea"
              placeholder="请输入内容,至少8个字"
      />
      <van-uploader v-model="imgList" result-type="file" style="margin:10px"
                    :before-delete="delPic"
                    :after-read="afterRead"
                    :before-read = "beforeRead"
                    upload-text="添加图片"
      />

    </van-cell-group>
  </div>
</template>

<script>
  import {Toast} from "vant"
export default {
  name: 'addPost',
  props: ["postItem"],
  data:function(){
    return {
      imgList:[]
    }
  },
  methods:{
    afterRead(file,detail){
      this.imgList.forEach(function(item){
        item.url = item.file.url;
      })
    },
    beforeRead:function(file,detail){
      var app = this;
      var formData = new FormData();
      var filename = file.name;
      formData.append('file',file,file.name)

      return app.axios.post("/uploadFile",formData,{
        headers: {'Content-Type': 'multipart/form-data1'}
      }).then(function(res){
        if(res.data.errcode=='suc'){
          var imgUrl = res.data.data.url;
          file.url = imgUrl;

          var textPos= app.$refs.postContent.$refs.input.selectionStart;
          app.postItem.content = app.postItem.content.substr(0,textPos) +'[图片:'+filename+']' + app.postItem.content.substr(textPos);

          return Promise.resolve();
        }
        else{
          return Promise.reject();
        }
      })



    },
    delPic:function(files,detail){

      var app = this;
      var tag = '[图片:'+ files.file.name+']';
      console.log("delPic",tag);
      app.postItem.content = app.postItem.content.replace(tag,'');

      return Promise.resolve();
    },
    saveEdit:function(){
          var app = this;

        if(!app.postItem.content || app.postItem.content.length<8 ){
          Toast('填写内容,至少8个字');
          app.$refs.postContent.focus();
          return ;
        }

        var content = app.postItem.content;
        app.imgList.forEach(function(item){
          console.log("item",item);
          content = content.replace('[图片:'+item.file.name+']','<img src="'+item.url+'" style="max-width: 80%">')
        });


          app.axios.post("/editPost",{
              pid:app.postItem.pid,
              content:content
          })
              .then(function(res){
                  if(res.data.errcode=="suc"){
                      app.imgList.splice(0);
                      app.$emit('editOk')
                  }
              })
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
